import { valibotResolver } from '@hookform/resolvers/valibot';
import { addDays } from 'date-fns';
import { date, nonEmpty, nullable, number, object, pipe, string } from 'valibot';

export const EQUIPMENT_DEACTIVATE_FIELDS = {
  IS_INDEFINITELY: 'isIndefinitely',
  DEACTIVATE_DATE: 'deactivate_date',
  DEACTIVATE_RANGE_START: 'deactivate_range_start',
  DEACTIVATE_RANGE_END: 'deactivate_range_end',
  REMIND_DATE: 'remind_date',
  DEACTIVATE_REASON: 'deactivate_reason',
};

export const schemaEquipmentDeactivate = valibotResolver(
  object({
    [EQUIPMENT_DEACTIVATE_FIELDS.IS_INDEFINITELY]: number(),
    [EQUIPMENT_DEACTIVATE_FIELDS.DEACTIVATE_DATE]: date('This field is required.'),
    [EQUIPMENT_DEACTIVATE_FIELDS.DEACTIVATE_RANGE_START]: date(),
    [EQUIPMENT_DEACTIVATE_FIELDS.DEACTIVATE_RANGE_END]: date(),
    [EQUIPMENT_DEACTIVATE_FIELDS.REMIND_DATE]: nullable(date()),
    [EQUIPMENT_DEACTIVATE_FIELDS.DEACTIVATE_REASON]: pipe(string(), nonEmpty('This field is required.')),
  }),
);

export const equipmentDeactivateDefaultValue = (currentFacilityDateTime) => {
  const currentDateTime = currentFacilityDateTime || new Date();

  return {
    [EQUIPMENT_DEACTIVATE_FIELDS.IS_INDEFINITELY]: 0,
    [EQUIPMENT_DEACTIVATE_FIELDS.DEACTIVATE_DATE]: currentDateTime,
    [EQUIPMENT_DEACTIVATE_FIELDS.DEACTIVATE_RANGE_START]: currentDateTime,
    [EQUIPMENT_DEACTIVATE_FIELDS.DEACTIVATE_RANGE_END]: addDays(currentDateTime, 1),
    [EQUIPMENT_DEACTIVATE_FIELDS.REMIND_DATE]: null,
    [EQUIPMENT_DEACTIVATE_FIELDS.DEACTIVATE_REASON]: '',
  };
};
